// Plus enquiries use the shared Formspree dialog. No billing requests are made.
export const PLUS_CONTACT_EMAIL = "peraperaeikaiwa@gmail.com";
export const PLUS_ENQUIRY_URL = "https://formspree.io/f/xzdywqby";

export function getPlusContactUrl() {
  return PLUS_ENQUIRY_URL;
}
